import React, { useState, useEffect } from 'react';
import EditIcon from '../../../assets/icons/edit.svg';
import CalendarIcon from '../../../assets/icons/calendar.svg';
import AccountIcon from '../../../assets/icons/card-account-details-outline.svg';
import PhoneIcon from '../../../assets/icons/phone-in-talk.svg';
import WhatsappIcon from '../../../assets/icons/whatsapp.svg';
import ScreenLoader from '../../../components/common/ScreenLoader';
import ProgressModal from '../../../components/common/modals/progress';
import EditPersonalInfoModal from '../../../components/common/modals/edit-teacher/EditPersonalInfo';
import { useLocation } from 'react-router';
import { AuthenticatedGETRequest } from '../../../utils';
import EditTeacherAddressDetailsModal from '../../../components/common/modals/edit-teacher/EditAddressDetails';
import EditTeacherEducationalInfoModal from '../../../components/common/modals/edit-teacher/EditEducationalInfo';

const TeacherDetails = ({ createNotification }) => {
    const { search } = useLocation();
    const [teacher, setTeacher] = useState(null);
    const [progressModel, setProgressModelOpening] = useState(false);
    const [editPersonalInfo, setEditPersonalInfo] = useState(false);
    const [editAddress, setEditAddress] = useState(false);
    const [editEducationInfo, setEditEducationInfo] = useState(false);

    useEffect(() => {
        const fetchTeacherRecord = async (teacherId) => {
            try {
                const { data } = await AuthenticatedGETRequest(`teachers/${teacherId}`);
                setTeacher(data);
            } catch (error) {
                createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
            }
        };
        fetchTeacherRecord(search.replace('?id=', ''));
    }, [createNotification, search]);

    return teacher ? (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            <ProgressModal open={progressModel} onClose={() => setProgressModelOpening(false)} />
            {/* Edit Personal Details */}
            {editPersonalInfo && (
                <EditPersonalInfoModal
                    id={teacher.id}
                    teacher={teacher}
                    setState={setTeacher}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditPersonalInfo(false)}
                />
            )}
            {/* Edit Address Details */}
            {editAddress && (
                <EditTeacherAddressDetailsModal
                    id={teacher.id}
                    teacher={teacher}
                    setState={setTeacher}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditAddress(false)}
                />
            )}
            {/* Edit Education Details  */}
            {editEducationInfo && (
                <EditTeacherEducationalInfoModal
                    id={teacher.id}
                    teacher={teacher}
                    setState={setTeacher}
                    onError={(error) => createNotification('error-toast', error)}
                    onClose={() => setEditEducationInfo(false)}
                />
            )}

            {/* Personal information */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '12px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>ذاتی معلومات</h2>

                    <div
                        className='flex alignCenter pointer'
                        onClick={() => setEditPersonalInfo(true)}
                    >
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>

                <div
                    className='flex justifyBetween alignStart w-100'
                    style={{
                        background: '#ffffff',
                        padding: '12px 24px 6px',
                        minHeight: 120,
                    }}
                >
                    <div className='flex justifyStart'>
                        <img
                            src={teacher.image_url}
                            alt='profile_image'
                            height={120}
                            width={120}
                            style={{ borderRadius: '50%', border: '1px solid #757575' }}
                        />

                        <div className='flex column' style={{ marginRight: 16 }}>
                            <div className='flex alignCenter' style={{ marginTop: 8 }}>
                                <h2 style={{ color: '#000000' }}> {teacher.name}</h2>
                            </div>

                            <div className='flex alignCenter' style={{ marginTop: 4 }}>
                                <h4 style={{ color: '#000000', marginLeft: 12 }}>تاریخ پیدائش: </h4>
                                <img
                                    src={CalendarIcon}
                                    alt='تاریخ پیدائش'
                                    height={16}
                                    width={16}
                                    style={{ objectFit: 'contain' }}
                                />
                                <h5
                                    style={{
                                        color: '#000000',
                                        marginRight: 12,
                                        fontFamily: 'CircularStd',
                                    }}
                                >
                                    {teacher.date_of_birth}
                                </h5>
                            </div>

                            <div className='flex alignCenter' style={{ marginTop: 4 }}>
                                <h4 style={{ color: '#000000', marginLeft: 10 }}>
                                    شناختی کارڈ نمبر:
                                </h4>
                                <img
                                    src={AccountIcon}
                                    alt='شناختی کارڈ نمبر'
                                    height={16}
                                    width={16}
                                    style={{ objectFit: 'contain' }}
                                />
                                <h5
                                    style={{
                                        color: '#000000',
                                        marginRight: 12,
                                        fontFamily: 'CircularStd',
                                    }}
                                >
                                    {teacher.cnic}
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div
                        className='flex column'
                        style={{
                            background: '#ECFAF6',
                            borderRadius: 4,
                            marginTop: 8,
                            border: '1px solid #058464',
                            minWidth: 300,
                            padding: '12px 16px 10px',
                        }}
                    >
                        <h3 style={{ color: '#000000' }}>رابطے کی معلومات </h3>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <div className='flex alignCenter'>
                                <img
                                    src={WhatsappIcon}
                                    alt='موبائل نمبر'
                                    height={16}
                                    width={16}
                                    style={{ objectFit: 'contain' }}
                                />
                                <h5
                                    style={{
                                        color: '#000000',
                                        marginRight: 12,
                                        fontFamily: 'CircularStd',
                                    }}
                                >
                                    {teacher.primary_phone_number}
                                </h5>
                            </div>
                            {teacher.secondary_phone_number && (
                                <div
                                    style={{
                                        background: '#42424294',
                                        height: 16,
                                        width: 2,
                                        margin: '0 8px',
                                    }}
                                />
                            )}
                            {teacher.secondary_phone_number && (
                                <div className='flex alignCenter'>
                                    <img
                                        src={PhoneIcon}
                                        alt='موبائل نمبر'
                                        height={16}
                                        width={16}
                                        style={{ objectFit: 'contain' }}
                                    />
                                    <h5
                                        style={{
                                            color: '#000000',
                                            marginRight: 8,
                                            fontFamily: 'CircularStd',
                                        }}
                                    >
                                        {teacher.secondary_phone_number}
                                    </h5>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#eeeded',
                        padding: '14px 24px 6px',
                        borderTop: '1px solid #757575',
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div className='flex alignCenter'>
                        <h3 style={{ color: '#757575' }}>والد کا نام: </h3>
                        <h3 style={{ color: '#757575', marginRight: 12 }}>
                            {teacher.father_name}
                        </h3>
                    </div>
                </div>
            </div>

            <br />
            {/* Address */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '12px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>پتا کی معلومات</h2>

                    <div className='flex alignCenter pointer' onClick={() => setEditAddress(true)}>
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>
                <div
                    className='flex  column justifyCenter alignStart w-100'
                    style={{
                        background: '#ffffff',
                        padding: '16px 24px 8px',
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div className='flex alignCenter'>
                        <h2 style={{ color: '#000000' }}>مستقل پتا : </h2>
                        <h3 style={{ color: '#000000', marginRight: 16 }}>
                            {teacher.permanent_address} {`،`} {teacher.permanent_city} {`،`}
                            {teacher.permanent_state}
                        </h3>
                    </div>

                    <div className='flex alignCenter' style={{ marginTop: 12 }}>
                        <h2 style={{ color: '#000000' }}>موجودہ پتا: </h2>
                        <h3 style={{ color: '#000000', marginRight: 16 }}>
                            {teacher.current_address} {`،`} {teacher.current_city} {`،`}
                            {teacher.current_state}
                        </h3>
                    </div>
                </div>
            </div>

            <br />
            {/* Education */}
            <div
                className='flex column w-100'
                style={{ border: '1px solid rgba(0,0,0,0.3)', borderRadius: 6 }}
            >
                <div
                    className='flex justifyBetween alignCenter w-100'
                    style={{
                        background: '#058464',
                        padding: '18px 24px 6px',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                >
                    <h2 style={{ color: '#ffffff' }}>تعلیم سے متعلق معلومات</h2>

                    <div
                        className='flex alignCenter pointer'
                        onClick={() => setEditEducationInfo(true)}
                    >
                        <img src={EditIcon} alt='edit_icon' height={24} width={24} />
                        <h3 style={{ color: '#ffffff', marginRight: 12 }}> ترمیم کریں</h3>
                    </div>
                </div>
                <div
                    className='flex justifyBetween alignStart w-100'
                    style={{
                        background: '#ffffff',
                        padding: '16px 24px 8px',
                        borderBottomLeftRadius: 4,
                        borderBottomRightRadius: 4,
                    }}
                >
                    <div className='flex column justifyCenter alignStart'>
                        <div className='flex alignCenter'>
                            <h3 style={{ color: '#000000', minWidth: 80 }}> دینی تعلیم : </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>
                                {teacher.islamic_education}
                            </h3>
                        </div>

                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h3 style={{ color: '#000000', minWidth: 80 }}> عصرک تعلیم: </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>
                                
                                {teacher.regular_education}
                            </h3>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h3 style={{ color: '#000000', minWidth: 80 }}>اعزازات: </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>{teacher.awards} </h3>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h3 style={{ color: '#000000', minWidth: 80 }}>شعبہ تدریس: </h3>
                            <h3 style={{ color: '#000000', marginRight: 16 }}>
                                {teacher.department_of_teaching}
                            </h3>
                        </div>
                    </div>

                    <div
                        style={{
                            background: '#42424294',
                            height: '100%',
                            width: 2,
                        }}
                    />

                    <div className='flex column justifyCenter alignStart'>
                        <div className='flex alignCenter'>
                            <h3 style={{ color: '#000000', minWidth: 180 }}> سن فراغت : </h3>
                            <h4 style={{ color: '#000000', marginRight: 16 }}>
                                {teacher.degree_completion}
                            </h4>
                        </div>

                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h3 style={{ color: '#000000', minWidth: 180 }}> آغاز تدریس: </h3>
                            <h4 style={{ color: '#000000', marginRight: 16 }}>
                                
                                {teacher.beginning_of_teaching}
                            </h4>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h3 style={{ color: '#000000', minWidth: 180 }}>
                                جامعہ نظامیہ رضویہ میں آغاز تدریس:
                            </h3>
                            <h4 style={{ color: '#000000', marginRight: 16 }}>
                                {teacher.beginning_of_teaching_in_jamia_nizamia_rizvia}
                            </h4>
                        </div>
                        <div className='flex alignCenter' style={{ marginTop: 8 }}>
                            <h3 style={{ color: '#000000', minWidth: 180 }}>دیگر خدمات: </h3>
                            <h3 style={{ color: '#000000', marginRight: 24 }}>
                                {teacher.other_services}
                            </h3>
                        </div>
                    </div>
                    <div
                        style={{
                            background: '#42424294',
                            height: '100%',
                            width: 2,
                        }}
                    />

                    <div
                        className='flex justifyBetween alignCenter'
                        style={{
                            background: '#ECFAF6',
                            borderRadius: 4,
                            marginTop: 8,
                            border: '1px solid #058464',
                            width: 240,
                            padding: '16px 0px 12px',
                        }}
                    >
                        <div
                            className='flex column justifyStart alignStart'
                            style={{ width: 160, paddingRight: 16 }}
                        >
                            <h3 style={{ color: '#000000' }}>تصانیف :</h3>
                            <h4 style={{ color: '#000000' }}> {teacher.writers_of}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <ScreenLoader />
    );
};

export default TeacherDetails;
